module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/assets.component.scss
// module id = ./src/app/assets/assets.component.scss
// module chunks = main